import { useEffect } from 'react';
import { logPfsAnalyticsEvent } from 'src/utils/utils';
import { UpdateOnboardingAnalytics } from 'src/utils/types';

export const useLogAnalytics = (analyticsData: Partial<UpdateOnboardingAnalytics>, delay: number = 300) => {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      logPfsAnalyticsEvent(analyticsData as UpdateOnboardingAnalytics);
    }, delay);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);
}; 